import React from 'react';
import '../stylesheets/stylesComponents/tag.scss';
import variables from '../stylesheets/variables.scss';
import useUserProfile from '../customHooks/useUserProfile';

const Tag = props => {
    const {
        className,
        text,
        color = variables.primary700,
        style,
        variant = 'contained',
        button = false,
        onClick,
    } = props;
    const { translate } = useUserProfile();

    const containedStyles = {
        color,
        backgroundColor: `${color}1A`,
    };

    const outlinedStyles = {
        color,
        backgroundColor: 'transparent',
        border: `1px solid ${color}`,
    };

    const styles = variant === 'contained' ? containedStyles : outlinedStyles;

    const Component = button ? 'button' : 'div';
    return (
        <div className={variant === 'outlined' || button ? '' : 'tag__wrapper'}>
            <Component
                onClick={onClick}
                className={`tag__container ${className || ''} ${
                    button ? 'tag__button' : ''
                }`}
                style={{
                    ...styles,
                    ...style,
                }}
            >
                {translate(text)}
            </Component>
        </div>
    );
};

export default Tag;
